import { useState, useEffect } from 'react';

const UNLOCK_KEY = 'designstack_unlocked';

export function useUnlock() {
  const [isUnlocked, setIsUnlocked] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem(UNLOCK_KEY) === 'true';
  });

  const unlock = () => {
    localStorage.setItem(UNLOCK_KEY, 'true');
    setIsUnlocked(true);
  };

  const lock = () => {
    localStorage.removeItem(UNLOCK_KEY);
    setIsUnlocked(false);
  };

  useEffect(() => {
    const handleStorageChange = () => {
      setIsUnlocked(localStorage.getItem(UNLOCK_KEY) === 'true');
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return {
    isUnlocked,
    unlock,
    lock,
  };
}